import React from 'react';
import { Link, HashRouter as Router } from 'react-router-dom';

var show = "true";

function Header(props){
    return(
    <header className="main-header">
        <div className="logo"><h1>Resource <span>HUB</span></h1><button onClick={props.handleClick}><span></span><span></span><span></span></button></div>
         {props.show % 2 ?
         <nav id="nav-bar">
           <Router>
            
              <Link to="/">HOME</Link>
              <Link to="/Books">BOOKS</Link>
              <Link to="/Notes">NOTES</Link>
              <Link to="/Syllabus">SYLLABUS</Link>
              <Link to="/Question-papers">QUESTION PAPERS</Link>
              <Link to="Imp-Links">IMP LINKS</Link>
            </Router>
          </nav>
          :
          <div className = "else"></div>}
    </header>
    )
}

export default Header;